import {ArrowDown2} from "iconsax-reactjs";

const components = {
  MuiButton: {
    styleOverrides: {
      root: {
        borderRadius: '8px',
        fontWeight: '600',
        fontSize: '14px',
        lineHeight: '18px',
        boxSizing: 'border-box',
        padding: '8px 12px',
        minHeight: '36px',
        minWidth: '36px',
        height: '36px',
        textTransform: 'capitalize',
        whiteSpace: 'nowrap',
      }
    }
  },
  MuiButtonBase: {
    defaultProps: {
      disableRipple: true,
    },
    styleOverrides: {
      root: {
        '&.MuiButton-containedPrimary': {
          color: '#fff',
          background: 'linear-gradient(90deg, #3B82F6 0%, #00BBFF 100%)',
          transition: 'background 0.3s ease',
          '&:hover': {
            background: 'linear-gradient(90deg, #00BBFF 0%, #3B82F6 100%)',
          },
          '&:active': {
            background: 'linear-gradient(90deg, #0950C4 0%, #0093D7 100%)',
          },
          boxShadow: 'none',
          '&:hover, &:active': {
            boxShadow: 'none',
          },
          '&:disabled': {
            opacity: '0.33',
            color: '#fff',
            background: 'linear-gradient(90deg, #3B82F6 0%, #00BBFF 100%)',
          },
        },
        '&.MuiButton-containedSecondary': {
          color: '#3B82F6',
          background: '#F8F9FA',
          transition: 'background 0.3s ease',
          '&:hover': {
            background: 'transparent',
          },
          '&:active': {
            background: '#E4EBF3',
          },
          boxShadow: 'none',
          '&:hover, &:active': {
            boxShadow: 'none',
          },
          '&:disabled': {
            opacity: '0.33',
            color: '#3B82F6',
            background: '#F8F9FA',
          },
        },
        '&.MuiButton-containedInfo': {
          color: '#3B82F6',
          background: '#FFFFFF',
          transition: 'background 0.3s ease',
          '&:hover': {
            border: '1px solid #FFFFFF',
            backgroundColor: 'transparent',
            color: '#FFFFFF'
          },
          '&:active': {
            background: '#E4EBF3',
          },
          boxShadow: 'none',
          '&:hover, &:active': {
            boxShadow: 'none',
          },
          '&:disabled': {
            opacity: '0.33',
            color: '#3B82F6',
            background: '#FFFFFF',
          },
        },
        '&.MuiButton-root:disabled': {
          opacity: '0.33',
        },
        '&.MuiButton-outlined:not(.MuiButton-outlinedError)' : {
          border: '1px solid #3B82F6',
          backgroundColor: 'transparent',
          color: '#3B82F6',
          '&:hover': {
            backgroundColor: '#DCF0FF',
          },
          '&:disabled': {
            opacity: '0.33',
            border: '1px solid #3B82F6',
            backgroundColor: 'transparent',
            color: '#3B82F6',
          },
        },
        '&.MuiButton-outlinedError': {
          backgroundColor: '#fff',
          '&:hover': {
            backgroundColor: '#EF44441A',
          },
          '&:disabled': {
            opacity: '0.33',
            border: '1px solid #EF4444',
            backgroundColor: '#EF4444',
            color: '#fff',
          },
        },
        '&.MuiButton-outlinedWarning': {
          backgroundColor: '#fff',
          border: '1px solid #EF4444',
          color: '#EF4444',
          '&:hover': {
            backgroundColor: '#EF44441A',
          },
        },
      },
    }
  },
  MuiDataGrid: {
    styleOverrides: {
      root: {
        '&.MuiDataGrid-root': {
          borderRadius: '16px',
          border: 'none',
        },
        '& .MuiDataGrid-main': {
          border: '1px solid #E4EBF3!important',
          borderRadius: '16px',
        },
        '& .MuiDataGrid-columnSeparator': {
          display: 'none',
        },
        '.MuiDataGrid-row:hover': {
          backgroundColor: '#F8F9FA!important',
        },
        '&  .MuiDataGrid-columnHeaders': {
          backgroundColor: '#E4EBF3',
          borderTopLeftRadius: '16px',
          borderTopRightRadius: '16px',
          fontSize: '14px',
          textTransform: 'capitalize',
          height: '52px',
          color: '#111827',
          '& .MuiDataGrid-columnHeader': {
            background: 'transparent',
            padding: '0 6px 0 16px',
          },
          '& .MuiDataGrid-columnHeader--sorted .MuiDataGrid-columnHeaderTitle': {
            fontWeight: '600!important',
          },
          '& .MuiDataGrid-columnHeaderTitle': {
            fontWeight: '400',
          },
          '& .MuiDataGrid-sortButton': {
            background: 'transparent',
          },
          '& .MuiDataGrid-filler, & .MuiDataGrid-scrollbarFiller': {
            display: 'none',
          },
        },
        '.MuiDataGrid-row:nth-child(even)': {
          background: '#F6FAFE'
        },
        '& .MuiDataGrid-cell': {
          display: 'flex',
          justifyContent: 'flex-start',
          alignItems: 'center',
          fontSize: '12px',
          fontWeight: '500',
          lineHeight: '16px',
          paddingLeft: '16px',
          boxSizing: 'border-box',
          color: '#111827'
        },
        '& .MuiDataGrid-cell:focus': {
          outline: 'none'
        },
        '& .MuiDataGrid-cell:focus-within': {
          outline: 'none'
        },
        '& .MuiDataGrid-columnHeader:focus': {
          outline: 'none'
        },
        '& .MuiDataGrid-columnHeader:focus-within': {
          outline: 'none'
        },
        '.MuiDataGrid-overlay': {
          zIndex: 99,
          height:'100%!important'
        },
        '& .MuiStack-root': {
          padding: '0',
          height: '36px',
          marginTop: '16px',
        }
      }
    }
  },
  MuiPagination: {
    styleOverrides: {
      root: {
        '& .MuiPaginationItem-root': {
          boxSizing: 'border-box',
          fontWeight: 500,
          width: '34px',
          height: '36px',
          borderRadius: '8px',
          '&:hover:not(.Mui-selected, .MuiPaginationItem-ellipsis)': {
            border: '1px solid #E4EBF3',
            backgroundColor: 'rgba(255, 255, 255, 0.1)!important',
          },
        },
        '& .Mui-selected': {
          backgroundColor: 'rgba(255, 255, 255, 0.1)!important',
          border: '1px solid #E4EBF3',
        },
        '& .MuiPaginationItem-ellipsis': {
          lineHeight: '32px',
          cursor: 'default'
        }
      }
    }
  },
  MuiFormControl: {
    styleOverrides: {
      root: {
        '& .MuiInputLabel-formControl[data-shrink|="false"]': {
          transform: 'translate(14px, 10px) scale(1)'
        }
      }
    }
  },
  MuiInputBase: {
    styleOverrides: {
      root: {
        '&.MuiInputBase-root': {
          height: '52px',
          lineHeight: '50px',
          fontWeight: '400',
          fontSize: '14px',
          background: '#FFFFFF',
          boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.05)',
          borderRadius: '8px',
          borderColor: '#E4EBF3',
        },
        '&.MuiInputBase-root.Mui-error': {
          borderColor: '#EF4444'
        },
        '&.MuiInputBase-root:not(.Mui-error):hover .MuiOutlinedInput-notchedOutline': {
          borderColor: '#BDC3CA'
        },
        '&.MuiInputBase-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
          borderWidth: '1px',
          borderColor: '#BDC3CA'
        },
        '& .MuiOutlinedInput-notchedOutline': {
          top: '-6px',
          border: '1px solid #E4EBF3',
        },
        '&.MuiInputBase-multiline': {
          height: 'auto'
        }
      }
    }
  },
  MuiSelect: {
    defaultProps: {
      IconComponent: ArrowDown2,
    },
    styleOverrides: {
      root: {
        '.MuiSelect-select': {
          height: '50px',
          paddingTop: 0,
          paddingBottom: 0,
        },
        '.MuiSelect-icon': {
          width: '16px',
          height: 'auto',
          marginTop: '-2px'
        }
      }
    }
  },
  MuiMenu: {
    styleOverrides: {
      paper: {
        borderRadius: 8,
        marginTop: 10,
        padding: 16,
        boxSizing: 'border-box',
        border: '1px solid #E4EBF3',
        minWidth: '178px',
        '&:not(#menu-appbar-paper) .MuiMenuItem-gutters': {
          display: 'flex',
          alignItems: 'center',
          gap: '6px',
          borderRadius: '8px',
          height: '40px',
          background: 'transparent',
          '& img': {
            marginLeft: '6px',
            marginTop: '4px'
          },
          '&:hover': {
            backgroundColor: '#F8F9FA',
          },
          '&.Mui-selected:not([data-value=""])': {
            border: '1px solid #3B82F6',
            background: 'transparent',
            marginBottom: '1px'
          },
          // '&[data-value=""]': {
          //   marginTop: '-14px',
          // },
          '&.Mui-disabled': {
            display: 'none',
          }
        }
      },
    },
  },
  MuiAutocomplete: {
    styleOverrides: {
      root: {
        '& .MuiAutocomplete-root': {
          height: '40px',
          borderRadius: '8px',
          border: '1px solid #E4EBF3',
        },
        '& .MuiAutocomplete-inputRoot': {
          paddingTop: '2px!important',
          height: '38px'
        },
        '& .MuiAutocomplete-endAdornment': {
          // top: '-2px!important'
        }
      }
    }
  },
  MuiLink: {
    defaultProps: {
      underline: "hover",
    },
  },
  MuiCardHeader: {
    defaultProps: {
      titleTypographyProps: {
        variant: "h6",
      },
    },
    styleOverrides: {
      action: {
        marginTop: "-4px",
        marginRight: "-4px",
      },
    },
  },
  MuiCard: {
    styleOverrides: {
      root: {
        borderRadius: "6px",
        backgroundImage: "none",
      },
    },
  },
  MuiPaper: {
    styleOverrides: {
      root: {
        backgroundImage: "none",
      },
    },
  },
  MuiDialog: {
    styleOverrides: {
      paper: {
        borderRadius: "16px",
      },
    }
  },
  MuiPickersDay: {
    styleOverrides: {
      day: {
        fontWeight: "300",
      },
    },
  },
  MuiPickersYear: {
    styleOverrides: {
      root: {
        height: "64px",
      },
    },
  },
  MuiPickersCalendar: {
    styleOverrides: {
      transitionContainer: {
        marginTop: "6px",
      },
    },
  },
  MuiPickersCalendarHeader: {
    styleOverrides: {
      iconButton: {
        backgroundColor: "transparent",
        "& > *": {
          backgroundColor: "transparent",
        },
      },
      switchHeader: {
        marginTop: "2px",
        marginBottom: "4px",
      },
    },
  },
  MuiPickersClock: {
    styleOverrides: {
      container: {
        margin: `32px 0 4px`,
      },
    },
  },
  MuiPickersClockNumber: {
    styleOverrides: {
      clockNumber: {
        left: `calc(50% - 16px)`,
        width: "32px",
        height: "32px",
      },
    },
  },
  MuiPickerDTHeader: {
    styleOverrides: {
      dateHeader: {
        "& h4": {
          fontSize: "2.125rem",
          fontWeight: 400,
        },
      },
      timeHeader: {
        "& h3": {
          fontSize: "3rem",
          fontWeight: 400,
        },
      },
    },
  },
  MuiPickersTimePicker: {
    styleOverrides: {
      hourMinuteLabel: {
        "& h2": {
          fontSize: "3.75rem",
          fontWeight: 300,
        },
      },
    },
  },
  MuiPickersToolbar: {
    styleOverrides: {
      toolbar: {
        "& h4": {
          fontSize: "2.125rem",
          fontWeight: 400,
        },
      },
    },
  },
  MuiChip: {
    styleOverrides: {
      root: {
        borderRadius: "6px",
      },
    },
  },
};

export default components;
